const customerCompanies = {
    id: "customer_companies",
    endpoint: "/customer-companies",
    withSelectedAccounts: true,
};

export default customerCompanies;
